export class CatalogState {
    constructor(
        public idKey?: string,
        public customerId?: string,
        public name?: string,
    ) {}
}
